import React from 'react';
import MyObjectivesPage from '../progress/MyObjectivessPage';
import ReportLayout from './ReportLayout';

export default function ObjectivesReportPage() {
  return (
    <ReportLayout
      title="Performance Agreement"
    >
      <MyObjectivesPage reportMode />
    </ReportLayout>
  );
}
